import React from "react";

const BalanceOccupation = (props) => {
  const {
    quarter
  } = props;

  return (
    <>
      {quarter == 'q1' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.000488281" width="8" height="8" rx="2" fill="#F5FAFF"/>
          <rect y="10.0005" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="0.000488281" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="10.0005" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
        </svg>
      }
      {quarter == 'q2' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.000488281" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect y="10.0005" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="0.000488281" width="8" height="8" rx="2" fill="#F5FAFF"/>
          <rect x="10" y="10.0005" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
        </svg>
      }
      {quarter == 'q3' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.000488281" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect y="10.0005" width="8" height="8" rx="2" fill="#F5FAFF"/>
          <rect x="10" y="0.000488281" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="10.0005" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
        </svg>
      }
      {quarter == 'q4' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.000488281" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect y="10.0005" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="0.000488281" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="10.0005" width="8" height="8" rx="2" fill="#F5FAFF"/>
        </svg>
      }
      {quarter == 'q1q2' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.00195312" width="18" height="8" rx="2" fill="#F5FAFF"/>
          <rect y="10.0039" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="10.0039" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
        </svg>
      }
      {quarter == 'q1q3' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.000488281" width="8" height="18" rx="2" fill="#F5FAFF"/>
          <rect x="10" y="0.000976562" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="10.001" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
        </svg>
      }
      {quarter == 'q2q4' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.00195312" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect y="10.002" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="0.000976562" width="8" height="18" rx="2" fill="#F5FAFF"/>
        </svg>
      }
      {quarter == 'q3q4' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.00390625" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect x="10" y="0.00390625" width="8" height="8" rx="2" fill="#96A5B6" fillOpacity="0.5"/>
          <rect y="10" width="18" height="8" rx="2" fill="#F5FAFF"/>
        </svg>
      }
    </>
  )
}

export default BalanceOccupation;